import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import PerfectScrollbar from "perfect-scrollbar";
import { Nav } from "reactstrap";
import { BackgroundColorContext } from "contexts/BackgroundColorContext";
import { useTranslation } from 'react-i18next';
import AppSwitcher from "./AppSwitcher";

let ps;

function Sidebar({ selectedApp, setSelectedApp, routes, logo, toggleSidebar, onNavigate }) {
    const { t } = useTranslation();
    const location = useLocation();
    const sidebarRef = React.useRef(null);
    const activeRoute = (routeName) => location.pathname === routeName ? "active" : "";

    useEffect(() => {
        if (navigator.platform.indexOf("Win") > -1 && sidebarRef.current) {
            ps = new PerfectScrollbar(sidebarRef.current, {
                suppressScrollX: true,
                suppressScrollY: false,
            });
            return () => {
                ps.destroy();
            };
        }
    }, []);

    const sidebarClick = (path) =>{
        toggleSidebar(); 
        onNavigate(path)
    }

    const renderNavItems = (routesArray) => {
        return routesArray.map((prop, key) => {
            if (prop.redirect) return null;
        
            return (
                <li className={activeRoute(prop.path)} key={key}>
                    <NavLink to={prop.layout + prop.path} className="nav-link" onClick={() => sidebarClick(prop.path)}>
                        <i className={prop.icon} />
                        <p>{t(`menu.${prop.name}`)}</p>
                    </NavLink>
                    {prop.hasChildren && prop.children.length}
                </li>
            );
        });
    };
      
    return (
        <BackgroundColorContext.Consumer>
            {({ color }) => (
                <div className="sidebar" data={color}>
                    <div className="sidebar-wrapper" ref={sidebarRef}>
                        <AppSwitcher selectedApp={selectedApp} setSelectedApp={setSelectedApp} toggleSidebar={toggleSidebar} />
                        <Nav>
                            {renderNavItems(routes)}
                        </Nav>
                    </div>
                </div>
            )}
        </BackgroundColorContext.Consumer>
    );
}

export default Sidebar;
